var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavEvr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 26,
    viewBox: "0 0 81 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9601 0H0V25.9599H25.9601V0Z",
    fill: "#353B7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.444 15.089V18.6038H21.0891V22.6459H6.3516V7.38133H4.84521V3.289H21.0891V7.38133H10.444V11.0217H18.7542V15.089H10.444Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4806 0H27.5205V25.9599H53.4806V0Z",
    fill: "#353B7D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3378 3.289L43.4126 22.6711H37.362L31.6377 3.289H35.8556L40.3748 18.9804L45.1199 3.289H49.3378Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0002 0H55.04V25.9599H81.0002V0Z",
    fill: "#353B7D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.539 15.9928C73.0161 16.6707 73.4429 17.2983 73.7944 17.8758C74.1459 18.4281 74.4723 18.9804 74.7484 19.5077C75.0246 20.0349 75.2506 20.5621 75.4514 21.0643C75.6523 21.5915 75.828 22.1187 76.0037 22.6711H71.8361C71.4595 21.5915 70.9824 20.5872 70.4552 19.6583C69.928 18.7043 69.3003 17.7753 68.5722 16.8213H65.2833V22.6711H61.2913V7.25579H59.8101V3.289H69.4258C70.3799 3.289 71.2837 3.46475 72.1374 3.84134C72.991 4.19283 73.7191 4.69495 74.3467 5.32261C74.9744 5.95027 75.4514 6.67835 75.7778 7.50686C76.1042 8.33536 76.2548 9.23919 76.2046 10.1932C76.1795 10.8711 76.0289 11.4988 75.828 12.0762C75.602 12.6536 75.3259 13.1809 74.9995 13.6579C74.6731 14.1349 74.2965 14.5617 73.8697 14.9634C73.4429 15.3149 73.0161 15.6664 72.539 15.9928ZM72.2378 10.0426C72.2378 9.666 72.1625 9.2894 72.0118 8.96302C71.8612 8.63664 71.6603 8.33536 71.4093 8.0592C71.1582 7.80813 70.8569 7.60728 70.5305 7.45665C70.2041 7.30601 69.8275 7.23069 69.451 7.23069H65.2582V12.8294H69.451C69.8275 12.8294 70.2041 12.7541 70.5556 12.6034C70.9071 12.4528 71.1833 12.2519 71.4344 12.0009C71.6854 11.7498 71.8863 11.4485 72.0369 11.0971C72.1625 10.7958 72.2378 10.4443 72.2378 10.0426Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavEvr);
export default __webpack_public_path__ + "static/media/nav-evr.4a69b072a8f7170d493d5eed719e9728.svg";
export { ForwardRef as ReactComponent };